import React from 'react';
import styled from 'styled-components';
import { cssSpacing, Type } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import {
  StyledIconExclamationActive,
  TextButton,
  TypeWithMargin,
} from '@components/shared/styles';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const RetryLink = styled.div`
  padding-top: ${cssSpacing('tighter-2', '16px')};
`;

const TypeCapital = styled(Type)`
  text-transform: uppercase;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 300px;
`;

interface RetryableLoadingErrorProps {
  onRetry: () => void;
  customMessage?: string;
}

export const RetryableLoadingError = ({
  onRetry,
  customMessage,
}: RetryableLoadingErrorProps) => {
  const t = useT();

  return (
    <Content>
      <StyledIconExclamationActive
        iconSize={32}
        data-testid="exclamation-active-icon"
      />
      <TypeWithMargin
        variant="celloCanon"
        semanticColor="textBase"
        marginBottom={cssSpacing('tighter-2', '16px')}
        marginTop={cssSpacing('tighter-2', '16px')}
      >
        {t(
          'atlas.errors.error_loading',
          'Error loading',
          'Loading error state',
        )}
      </TypeWithMargin>
      <TextContainer>
        <TypeWithMargin variant="viola" semanticColor="textBase">
          {customMessage
            ? customMessage
            : t(
                'atlas.errors.problem_try_again',
                'There was a problem loading the content on our end. Please try again.',
                'General error message and direction for user to try again',
              )}
        </TypeWithMargin>
      </TextContainer>
      <RetryLink>
        <TextButton onClick={onRetry}>
          <TypeCapital
            variant="viola"
            semanticColor="textBrightAccent"
            weight="bold"
          >
            {t(
              'atlas.errors.try_loading_again',
              'Try loading again',
              'Text to guide user to try loading again',
            )}
          </TypeCapital>
        </TextButton>
      </RetryLink>
    </Content>
  );
};
